const NBSP = String.fromCharCode(160)
const THOUSANDS = /\B(?=(\d{3})+(?!\d))/g

const groupThousands = (digits: string): string => digits.replace(THOUSANDS, '.')

export const formatNumber = (value: number): string => {
    const rounded = Math.round(value)
    const sign = rounded < 0 ? '-' : ''

    return `${sign}${groupThousands(Math.abs(rounded).toString())}`
}

export const formatEuro = (value: number): string => {
    const cents = Math.round(value * 100)
    const euros = Math.floor(cents / 100)
    const rest = (cents % 100).toString().padStart(2, '0')

    return `€${NBSP}${groupThousands(euros.toString())},${rest}`
}
